<template>
  <div class="template-b">
    <div class="chunk-list">
      <template v-if="data.length == 1">
        <div class="chunk-a" style="margin-left: 0"></div>
        <div class="chunk-b" @click="handleClick(data[0])">
          <img :src="data[0].icon" alt="" />
        </div>
      </template>
      <template v-if="data.length > 1">
        <div
          class="chunk-a"
          style="margin-left: 0"
          @click="handleClick(data[1])"
        >
          <img :src="data[1].icon" alt="" />
        </div>
        <div class="chunk-b" @click="handleClick(data[0])">
          <img :src="data[0].icon" alt="" />
        </div>
        <div
          class="chunk-a common-a"
          v-for="item in data.slice(2)"
          :key="item.id"
          @click="handleClick(item)"
        >
          <img :src="item.icon" alt="" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import os from '@utils/os'
export default {
  props: {
    data: {
      type: Array
    }
  },
  data () {
    return {}
  },
  methods: {

    handleClick (item) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          let targetUrl = item.content_url
          // 判断是否需要追加 pf 和 uid 参数（CCAapp 跳转场景）
          const isDocbookUrl = /m\.docbook\.com\.cn|docbook\.com\.cn/.test(targetUrl)
          if (isDocbookUrl && this.$route.query.uid && this.$route.query.platform) {
            targetUrl = os.appendQuery(targetUrl, {
              platform: this.$route.query.platform,
              uid: this.$route.query.uid
            })
          }
          if (os.isPC()) {
            if (os.isInWechatMiniProgram()) {
              //   window.location.href = targetUrl
              window.go(targetUrl)
            } else {
              window.open(targetUrl)
            }
          } else {
            // window.location.href = targetUrl
            window.go(targetUrl)
          }
        }
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chunk-list {
  width: 100%;
  height: auto;
  padding: 0.2rem 0.48rem 0.2rem 0.48rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
// flex-wrap: wrap;
.chunk-a {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-left: 5%;
  overflow: hidden;
  width: 30%;
  height: 4.5rem;
}
.common-a:nth-child(3n) {
  margin-left: 0rem !important;
}
.chunk-b {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-left: 5%;
  width: 65%;
  height: 4.5rem;
}
.chunk-b img,
.chunk-a img {
  width: 100%;
  height: 100%;
}
</style>
